import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_se_t1">
              <div className="_tit">공제 대상</div>
            </div>
            <div className="_col _col_se_t1_half">
              <div className="_tit">구분</div>
            </div>
            <div className="_col _col_se_t1_half">
              <div className="_tit">공제한도</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_se_t1">
              <div className="_cont">근로자 본인</div>
            </div>
            <div className="_col _col_se_t1_half">
              <div className="_row" style={{ height: '50px' }}>
                <div className="_col _col_m_w_150">
                  <div className="_cont">보험료공제</div>
                </div>
                <div className="_col _col_m _col_m_w_150_ot">
                  <div className="_cont">국민건강보험료·노인장기요양보험,고용보험 등</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_m_w_150">
                  <div className="_cont">연금보험료</div>
                </div>
                <div className="_col _col_m _col_m_w_150_ot">
                  <div className="_row" style={{ height: '50px' }}>
                    <div className="_col">
                      <div className="_cont">국민연금보험료</div>
                    </div>
                  </div>
                  <div className="_row" style={{ height: '50px' }}>
                    <div className="_col">
                      <div className="_cont">국민연금보험료 외의 공적연금 보험료</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="_col _col_se_t1_half">
              <div className="_row" style={{ height: '50px' }}>
                <div className="_col">
                  <div className="_cont">근로자가 부담하는 보험료 전액</div>
                </div>
              </div>
              <div className="_row" style={{ height: '50px' }}>
                <div className="_col">
                  <div className="_cont">거주자 부담 보험료 전액</div>
                </div>
              </div>
              <div className="_row" style={{ height: '50px' }}>
                <div className="_col">
                  <div className="_cont">거주자 부담 기여금 또는 개인부담금 전액</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
